module.exports = "<!-- <div id=\"graph\">\n\n  <h2>Historical Data</h2>\n  <h4> 1 Month Range: {{ oneMonthAgo }} to {{ today }}</h4>\n\n</div> -->\n"